import { defineMessages } from 'react-intl'

const rules = defineMessages({
  requiredRule: {
    id: 'utils.validateRules.requiredRule',
    defaultMessage: '{item} is required, Please Check it!',
    description: '校验规则: 非空',
  },
  validRule: {
    id: 'utils.validateRules.validRule',
    defaultMessage: 'Please enter a valid {item}',
    description: '校验规则: 格式校验',
  },
  expireDateRule: {
    id: 'utils.validateRules.expireDateRule',
    defaultMessage: 'The current expiry data has expired.',
    description: '校验规则: 有效期已过期',
  },
})

const formItems = defineMessages({
  formItemEmailAddress: {
    id: 'utils.formItem.emailAddress',
    defaultMessage: 'Email address',
    description: '校验表单: 邮箱',
  },
  formItemMobileNumber: {
    id: 'utils.formItem.mobileNumber',
    defaultMessage: 'Mobile number',
    description: '校验表单: 手机号',
  },
  formItemIABNNumber: {
    id: 'utils.formItem.IBANNumber',
    defaultMessage: 'IBAN number',
    description: '校验表单: 银行账号',
  },
  formItemExpiryDate: {
    id: 'utils.formItem.expireDate',
    defaultMessage: 'Expiry date',
    description: '校验表单: 过期时间',
  },
  formItemCardNumber: {
    id: 'utils.formItem.cardNumber',
    defaultMessage: 'Card number',
    description: '校验表单: 卡号',
  },
  formItemName: {
    id: 'utils.formItem.name',
    defaultMessage: 'Name',
    description: '校验表单: 姓名',
  },
  formItemSecurityCode: {
    id: 'utils.formItem.securityCode',
    defaultMessage: 'Security code',
    description: '校验表单: CVV',
  },
  formItemCardHolderName: {
    id: 'utils.formItem.cardHolderName',
    defaultMessage: 'Card holder name',
    description: '校验表单: 持卡人姓名',
  },
  formItemHolderName: {
    id: 'utils.formItem.holderName',
    defaultMessage: 'Holder name',
    description: '校验表单: 持卡人姓名',
  },
  formItemAgreement: {
    id: 'utils.formItem.agreement',
    defaultMessage: 'Agreement',
    description: '校验表单: 协议',
  },
  formItemBankName: {
    id: 'utils.formItem.bankName',
    defaultMessage: 'Bank name',
    description: '校验表单: 银行名称',
  },
  formItemAmount: {
    id: 'utils.formItem.amount',
    defaultMessage: 'Amount',
    description: '校验表单: 金额',
  },
})

const callApi = defineMessages({
  networkError: {
    id: 'utils.callAPI.networkError',
    defaultMessage: 'Network error, please try again later！',
    description: '网络错误',
  },
  systemError: {
    id: 'utils.callAPI.system',
    defaultMessage: 'System error, please try it later!',
    description: '系统错误',
  },
})

const index = defineMessages({
  openUriToastInfo: {
    id: 'utils.index.openUriToastInfo',
    defaultMessage: 'Only support Android and iOS system!',
    description: 'open Uri Toast Info',
  },
  showBuyerNotMatchAlertTitle: {
    id: 'utils.index.alertTitle',
    defaultMessage: 'Failed！',
    description: 'alert: Title',
  },
  showBuyerNotMatchAlertBtnBack: {
    id: 'utils.index.alertBtnBack',
    defaultMessage: 'BACK',
    description: 'alert: button back',
  },
  showBuyerNotMatchAlertBtnRemain: {
    id: 'utils.index.alertBtnRemain',
    defaultMessage: 'REMAIN',
    description: 'alert: button remain',
  },
})

export default {
  ...rules,
  ...formItems,
  ...callApi,
  ...index,
}
